import { render, staticRenderFns } from "./PmtaServerForm.vue?vue&type=template&id=6feaa754&scoped=true"
import script from "./PmtaServerForm.vue?vue&type=script&lang=js"
export * from "./PmtaServerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feaa754",
  null
  
)

export default component.exports